import Vue from 'vue'

export default {
  getAll() {
    return Vue.http.get(`/api/local/v1/countries`)
              .then((response) => Promise.resolve(response.data))
              .catch((error) => Promise.reject(error))
  }
}
